// extracted by mini-css-extract-plugin
module.exports = {"scrollUp":"style_scrollUp__PZkmN","scrollUpHidden":"style_scrollUpHidden__1droq"};